module.exports = __webpack_public_path__ + "static/media/31-2.26cb6690.mp3";